module.exports = __webpack_public_path__ + "img/addwl.a4327e1e.png";